import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { FieldConfig } from "./CashOutRefinanceCalculator.utils.esm.js";
import CashOutRefinanceContent from "./CashOutRefinanceContent.esm.js";
import CashOutRefinanceFields from "./CashOutRefinanceFields.esm.js";
const CashOutRefinanceCalculator = ({
  defaultValues
}) => {
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "cashOutRefinanceFields", editorMode: isEditor(), defaultValues: {
    [FieldConfig.homeValue.name]: 25e4,
    [FieldConfig.currentMortgageBalance.name]: 1e4,
    [FieldConfig.newLoanTerm.name]: LOAN_PROGRAMS.fixed20Year,
    [FieldConfig.newInterestRate.name]: 4.35,
    [FieldConfig.adjustCashOutAmount.name]: 19e4,
    [FieldConfig.fees.name]: 1e3,
    [FieldConfig.rollFees.name]: false,
    ...omitUndefined(defaultValues)
  }, children: /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    smDown: {
      flexDirection: "column-reverse"
    }
  }, children: /* @__PURE__ */ jsx(CalculatorLayout, { fields: /* @__PURE__ */ jsx(CashOutRefinanceFields, {}), content: /* @__PURE__ */ jsx(CashOutRefinanceContent, {}) }) }) });
};
export {
  CashOutRefinanceCalculator as default
};
